import React from "react";
// import HttpService from '../utils/Http.services';
// import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../components/Configurer";
// import Dashboard from "./profile/Dashboard";
import StagesManager from "../components/StagesManager";
import { checkTranslation, pathMaker, translate } from "../utils/useful";
// import EditProfile from "./profile/EditProfile";
import Cookies from "universal-cookie";
import PageStatusViewer from "../components/PageStatusViewer";
// import AccountType from "./profile/AccountType";
// import ChangePasword from "./profile/ChangePasword";
import AdminDashboard from "./admin/AdminDashboard";
import AdminFormApplet from "./admin/AdminFormApplet";
import { adminPages, adminSections } from "../variables/adminPages";
import Collapsible from "react-collapsible";
import Modal from "../components/Modal";
// import { logoutUser } from "../stores/actionsList";


class CommingSoon extends React.Component {

    state = {
        modules: [],
        collapses: {},
        pages: [
            { name: 'Dashboard', key: '', dontShowInDashboard: true },
            { name: 'Edit Profile', icon: 'https://www.flaticon.com/svg/static/icons/svg/2444/2444452.svg', key: 'edit' },
            { name: 'Account type', icon: 'https://www.flaticon.com/svg/static/icons/svg/744/744922.svg', key: 'type' },
            { name: 'Change Password', icon: 'https://www.flaticon.com/svg/static/icons/svg/3039/3039392.svg', key: 'password' },
        ]
    }


    componentDidMount() {

        this.setState({ isLoading: false }, () => {
            // this.checkDefaultTab()
            let accessPages = Object.values(adminPages)
            this.setState({ modules: accessPages,pageStatus:200 })
        })

        return

        const cookies = new Cookies();
        let token = cookies.get('admintoken');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }

        // setInterval(() => {
        //     // console.log("HERE")
        //     if(this.configurer){
        //         console.log(this.configurer)
        //         console.log(this.configurer.props.settingsInfo)
        //     }
        // }, 2000);

        // if(this.configurer){
        //     console.log(this.configurer)
        //     console.log(this.configurer.settingsInfo)
        // }
    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                // this.checkDefaultTab()
                let accessPages = Object.values(adminPages)
                this.setState({ modules: accessPages })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(newProps) {
        let windowPath = this.props.location.pathname.split('/')
        windowPath = windowPath[windowPath.length - 1]

        // console.log(windowPath)
        // console.log(this.state.path)
        if (this.state.oldPath && this.state.oldPath != this.props.location.pathname) {
            this.setState({ oldPath: this.props.location.pathname }, () => {
                // this.checkDefaultTab()
            })
        }
    }



    // checkDefaultTab() {

    //     let def = ''
    //     let pageType = null
    //     let pageInfo = null
    //     let pathname = window.location.pathname.split('/')
    //     pathname.forEach((path, index) => {
    //         if (path == 'admin') {
    //             def = pathname[index + 1]
    //         }
    //     });

    //     // console.log(def)

    //     let pageIsValid = false

    //     Object.values(adminPages).forEach(page => {
    //         if (page.key.toLowerCase() === def?.toLowerCase()) {
    //             pageIsValid = true
    //             pageType = page.pageType
    //             // console.log(page)
    //             pageInfo = page
    //         }
    //     });
    //     if (!def) {
    //         def = ''
    //     }
    //     // console.log(def)
    //     if (def === '') {
    //         pageType = ''
    //         pageIsValid = true
    //     }
    //     if (pageIsValid) {
    //         // this.state.page = page
    //         // console.log(page)
    //         this.setState({ oldPath: this.props.location.pathname, pageStatus: 200 }, () => {
    //             this.setState({ path: def, }, () => {
    //                 this.stageManager.changeStage(pageType, () => {
    //                     window.scrollTo({ top: 0, behavior: 'smooth' })
    //                 })
    //                 setTimeout(() => {
    //                     this.setState({ page: null }, () => {

    //                         this.setState({ page: pageInfo })
    //                     })
    //                 }, 400);
    //             })

    //             // this.changePage(def)
    //             // if (def == '' || !def) {
    //             // this.stageManager.changeStage('dashboard')
    //             // this.stageManager.changeStage(def)
    //             // // this.props.history.push(pathMaker('/profile'))
    //             // } else {

    //             //     this.stageManager.changeStage(def)

    //             // }
    //         })
    //     } else {
    //         this.setState({ pageStatus: 404 })
    //     }

    // }



    changePage = (page) => {

        let path = pathMaker('/admin/' + page)

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }



    render() {
        return (

            <Configurer
                settingsInfo={{
                    showFooter: true, showTabBar: true, showHeader: true, headerTitle: "Admin", button: {},

                }}
                title={"Admin"}
                description={"Admin Description"}
                className="p-0 min-full-height"
                ref={el => this.configurer = el}
            >

                <PageStatusViewer status={this.state.pageStatus}>

                    <section className="w-100 text-center pt-5 flexcc">
                        <div>
                            <div style={{ borderRadius: 8, padding: '50px 50px' }}>
                                <img src="/images/barricade.svg" height="100px" />
                                <h1 className="text-big mb-1 mt-2">{translate('Comming Soon')}</h1>
                                <p className="text-small mt-1" style={{ color: '#000' }}>{translate('This section is not accessible now')}</p>
                                <p className="text-small mt-1" style={{ color: '#000' }}>{translate('It will be added later')}</p>

                            </div>
                        </div>
                    </section>
                </PageStatusViewer>

            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CommingSoon);
